/**
 * County slug → display label.
 * 'pinellas'    → 'Pinellas County'
 * 'palm-beach'  → 'Palm Beach County'
 * 'miami-dade'  → 'Miami-Dade County' (hyphen preserved)
 */
const HYPHEN_PROPER_NOUNS = new Set(['miami-dade']);

export function titleCaseCounty(slug: string): string {
  if (HYPHEN_PROPER_NOUNS.has(slug)) {
    const parts = slug.split('-').map((p) => (p[0]?.toUpperCase() ?? '') + p.slice(1));
    return `${parts.join('-')} County`;
  }
  const words = slug.split('-').map((w) => (w[0]?.toUpperCase() ?? '') + w.slice(1));
  return `${words.join(' ')} County`;
}
